import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PopoverFromTop } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import _ from 'lodash';
import { connect } from 'react-redux';

@connect(
  state => ({
    openedLazyPanels: state.panel.openedLazyPanels
  }), {closeLazyPanel}
)
export default class PropertyPanel extends Component {
  constructor(props) {
    super(props);

    this.onRequestClose = this.onRequestClose.bind(this);
  }

  onRequestClose() {
    if (this.props.onRequestClose) {
      this.props.onRequestClose(this.props.panelName);
    }
    this.props.closeLazyPanel(this.props.panelName);
  }

  getPopoverProps() {
    const openedPanel = _.find(this.props.openedLazyPanels, {panelName: this.props.panelName});
    if (openedPanel) {
      return {
        open: true,
        anchorEl: openedPanel.anchorEl
      };
    }
    return {};
  }

  render() {
    const filteredPopoverProps = _.omit(this.props.popoverProps, ['open', 'anchorEl', 'onRequestClose', 'style']);
    return (
      <PopoverFromTop
        {...this.getPopoverProps()}
        {...filteredPopoverProps}
        onClose={this.onRequestClose}
      >
        {this.props.children}
      </PopoverFromTop>
    );
  }
}

PropertyPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  popoverProps: PropTypes.object
};

PropertyPanel.defaultProps = {
  popoverProps: {}
};